export const PROVIDER_BY_ID_REQUEST = 'PROVIDER_BY_ID_REQUEST';
export const PROVIDER_BY_ID_SUCCESS = 'PROVIDER_BY_ID_SUCCESS';
export const PROVIDER_BY_ID_FAIL = 'PROVIDER_BY_ID_FAIL';
export const PROVIDER_BY_ID_RESET = 'PROVIDER_BY_ID_RESET';

export const PROVIDER_BY_NEED_REQUEST = 'PROVIDER_BY_NEED_REQUEST';
export const PROVIDER_BY_NEED_SUCCESS = 'PROVIDER_BY_NEED_SUCCESS';
export const PROVIDER_BY_NEED_FAIL = 'PROVIDER_BY_NEED_FAIL';
export const PROVIDER_BY_NEED_RESET = 'PROVIDER_BY_NEED_RESET';

export const PROVIDER_LIST_REQUEST = 'PROVIDER_LIST_REQUEST';
export const PROVIDER_LIST_SUCCESS = 'PROVIDER_LIST_SUCCESS';
export const PROVIDER_LIST_FAIL = 'PROVIDER_LIST_FAIL';
export const PROVIDER_LIST_RESET = 'PROVIDER_LIST_RESET';

export const UPDATE_PROVIDER_IS_ACTIVE_REQUEST = 'UPDATE_PROVIDER_IS_ACTIVE_REQUEST';
export const UPDATE_PROVIDER_IS_ACTIVE_SUCCESS = 'UPDATE_PROVIDER_IS_ACTIVE_SUCCESS';
export const UPDATE_PROVIDER_IS_ACTIVE_FAIL = 'UPDATE_PROVIDER_IS_ACTIVE_FAIL';

export const UPDATE_PROVIDER_REQUEST = 'UPDATE_PROVIDER_REQUEST';
export const UPDATE_PROVIDER_SUCCESS = 'UPDATE_PROVIDER_SUCCESS';
export const UPDATE_PROVIDER_FAIL = 'UPDATE_PROVIDER_FAIL';

export const ADD_PROVIDER_REQUEST = 'ADD_PROVIDER_REQUEST';
export const ADD_PROVIDER_SUCCESS = 'ADD_PROVIDER_SUCCESS';
export const ADD_PROVIDER_FAIL = 'ADD_PROVIDER_FAIL';
export const ADD_PROVIDER_RESET = 'ADD_PROVIDER_RESET';

export const DELETE_PROVIDER_REQUEST = 'DELETE_PROVIDER_REQUEST';
export const DELETE_PROVIDER_SUCCESS = 'DELETE_PROVIDER_SUCCESS';
export const DELETE_PROVIDER_FAIL = 'DELETE_PROVIDER_FAIL';
